/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_No_Target_FolderInputs */



/**
* | output |
* | --- |
* | "No Target Folder Selected" |
*
* @param {Batch_Subtitle_Export_No_Target_FolderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_no_target_folder = /** @type {((inputs?: Batch_Subtitle_Export_No_Target_FolderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_No_Target_FolderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun dossier cible sélectionné")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Zielordner ausgewählt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna cartella di destinazione selezionata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целевая папка не выбрана")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ninguna carpeta de destino seleccionada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择目标文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ターゲットフォルダが選択されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई लक्ष्य फ़ोल्डर चयनित नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma pasta de destino selecionada")
	return /** @type {LocalizedString} */ ("No Target Folder Selected")
});